import React, { useState } from "react";
import { Get, Remove, Set } from "../../../../../Request";

export const useProblem = () => {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modal, setModal] = useState({
        modal: false,
        modalData: {}
    });
    const [filter, setFilter] = useState('waiting');
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [form, setForm] = useState({
        describe: '',
        action: 'done'
    });
    const getData = async (data, pageNumber, limit = 15) => {
        setLoading(true);
        return await Get({
            url: "/problem/list",
            data: {
                limit: limit,
                ...data
            },
            page: pageNumber,
        }).then(data => {
            setList(data);
            setLoading(false);
        });
    };
    const handlerSearch = data => {
        getData({ search: data, filter });
    };
    const sortHandler = (value) => {
        setFilter(value);
        getData({ filter: value });
    };
    const toggleStatus = async () => {
        setLoadingBtn(true);
        return await Set({
            url: "/problem/toggle",
            data: {
                problemid: modal.modal,
                ...form
            }
        }).then(() => {
            setLoadingBtn(false);
            setModal({
                modal: false,
                modalData: {}
            });
        });
    };
    const sendData = async (data) => {
        setLoadingBtn(true);
        return await Set({
            url: "/problem/add",
            data
        }).then(() => {
            setLoadingBtn(false);
            setModal({
                modal: false,
                modalData: {}
            });
        });
    };
    return {
        list,
        loading,
        getData,
        handlerSearch,
        sortHandler,
        modal,
        setModal,
        toggleStatus,
        filter,
        setForm,
        form,
        loadingBtn,
        sendData
    };
};
